var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaveClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_885_28075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.45457 10.0042L12.012 0.729223C12.6899 -0.102832 13.9177 -0.242783 14.7678 0.412444C36.0458 16.8132 42.2218 31.065 42.8361 39.5124C42.974 41.4088 40.9051 41.5634 40.0869 39.847C32.275 23.4579 15.8653 15.8554 5.68265 13.4145C4.17164 13.0523 3.47306 11.2088 4.45457 10.0042Z",
    fill: "url(#paint0_linear_885_28075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92822 31.9354C15.4626 21.0968 28.9856 9.95764 37.804 3.96208C38.8212 3.27049 40.2008 3.69007 40.6965 4.81578L43.3136 10.7583C43.8158 11.8986 43.1606 13.2146 41.9599 13.5475C27.6177 17.5236 17.8865 25.0965 12.2576 32.7561C10.9581 34.5245 8.93026 33.8898 9.92822 31.9354Z",
    fill: "url(#paint1_linear_885_28075)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_885_28075",
    x: 0,
    y: 0,
    width: 47.4839,
    height: 49.041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_885_28075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_885_28075",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_885_28075",
    x1: 23.7419,
    y1: -3.16328e-7,
    x2: 18.2256,
    y2: 29.7397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB332E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_885_28075",
    x1: 23.7419,
    y1: -3.16328e-7,
    x2: 18.2256,
    y2: 29.7397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB332E"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaveClear);
export default __webpack_public_path__ + "static/media/cave-clear.33f8b4df862e2a1bfb372a1c9b79dc95.svg";
export { ForwardRef as ReactComponent };